import React from 'react';

const NotificationDrawer = ({ notifications, unreadCount, markAllRead, openPreview, onClose, show }) => {
    if (!show) return null;

    return (
        <>
            <div className="notif-drawer-overlay" onClick={onClose} />
            <div className="notif-drawer">
                <div className="notif-drawer-header">
                    <span className="notif-drawer-title">
                        Notifications
                        {unreadCount > 0 && <span className="notif-drawer-badge">{unreadCount}</span>}
                    </span>
                    <div className="notif-drawer-actions">
                        {unreadCount > 0 && (
                            <button className="mark-all-read-btn" onClick={markAllRead}>
                                Mark all as read
                            </button>
                        )}
                        <button className="notif-drawer-close" onClick={onClose}>&times;</button>
                    </div>
                </div>
                <div className="notif-drawer-body">
                    {notifications.length === 0 ? (
                        <div className="notification-empty">
                            <i className="fa fa-bell-slash-o"></i><br />No notifications
                        </div>
                    ) : notifications.map((n) => (
                        <div key={n.id} className={`notification-item${n.unread ? ' unread' : ''}`}>
                            <span className={`notification-item-icon ${n.type}`}>
                                {n.initial}
                            </span>
                            <div className="notification-item-content">
                                <div className="notification-item-title" dangerouslySetInnerHTML={{ __html: n.title }}></div>
                                {n.time && <div className="notification-item-time">{n.time}</div>}
                            </div>
                            <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}>
                                <i className="fa fa-eye"></i>
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default NotificationDrawer;
